var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.params.withdraw == 'pay')?[_c('h4',[_vm._v("Paykasa Para Yatır")]),_vm._v(" "),_c('div',{staticClass:"paykasa_wrapper",style:({ backgroundImage: 'url(static/assets/img/paykasa_bg.png)' })},[_c('paykasaForm')],1)]:_vm._e(),_vm._v(" "),(_vm.$route.params.withdraw == 'withdraw')?[_c('paykasaWithdraw')]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9ec8f1fe","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/payments/gateways/paykasa.vue
// module id = xRFi
// module chunks = 0